import { useReducer } from 'react';

export const variantTableReducer = (state, action) => {
  const updatedVariantValues = [...state.variantValues];
  const variantNamesLength = state.variantNames.length;
  switch (action.type) {
    case 'ADD_VARIANT_NAME':
      if (variantNamesLength === 2) return state; // Không cho phép thêm quá 2 variant name
      return {
        ...state,
        variantNames: [
          ...state.variantNames,
          (state.variantNames[variantNamesLength - 1] ?? 0) + 1,
        ],
        variantValues: [...state.variantValues, [1]],
      };
    case 'SUB_VARIANT_NAME':
      if (state.variantNames.length <= 0) return state; // Không cho phép giảm dưới 1 variant name
      return {
        ...state,
        variantNames: state.variantNames.filter(
          (_, index) => index !== action.payload.index
        ),
        variantValues: state.variantValues.filter(
          (_, index) => index !== action.payload.index
        ),
      };
    case 'ADD_VARIANT_VALUE':
      updatedVariantValues[action.payload.index] = [
        ...updatedVariantValues[action.payload.index],
        updatedVariantValues[action.payload.index][
          updatedVariantValues[action.payload.index].length - 1
        ] + 1,
      ];
      return {
        ...state,
        variantValues: updatedVariantValues,
      };
    case 'SUB_VARIANT_VALUE':
      // if (updatedVariantValues[action.payload.index].length <= 1) return state; // Không cho phép giảm dưới 1 variant value
      updatedVariantValues[action.payload.index] = updatedVariantValues[
        action.payload.index
      ].filter((_, index) => index !== action.payload.valueIndex);
      return {
        ...state,
        variantValues: updatedVariantValues,
      };
    case 'UPDATE_ALL':
      return {
        ...state,
        variantValues: action.payload.variantValues,
        variantNames: action.payload.variantNames,
      };
    default:
      return state;
  }
};
